<template>
  <div>
    <section-collapseable
      title="Lead Info"
      collapseable
      editable
      hide-initial-when-expanded
      @edit="$refs.leadInfoModal.open(record)"
    >
      <app-key-value-item
        v-for="field in visibleCustomFields"
        :key="field.id"
        :label="field.label"
        :value="field.value"
        :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
        :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
        :is-url="field.type === ENUMS.CustomFieldTypeEnum.Url.value"
        :is-time="field.type === ENUMS.CustomFieldTypeEnum.Time.value"
      ></app-key-value-item>

      <!-- Expanded Section -->
      <template v-slot:expanded>
        <app-key-value-item
          v-for="field in customFields"
          :key="field.id"
          :label="field.label"
          :value="field.value"
          :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
          :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
          :is-url="field.type === ENUMS.CustomFieldTypeEnum.Url.value"
          :is-time="field.type === ENUMS.CustomFieldTypeEnum.Time.value"
        ></app-key-value-item>
      </template>
    </section-collapseable>

    <modal-container>
      <modal-crud-form
        ref="leadInfoModal"
        title="Lead Info"
        form-component="lead-info-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
export default {
  name: "LeadInfo",
  computed: {
    canAccessHiddenFields() {
      const authUser = this.$store.getters.authUser;

      if (authUser.is_owner) return true;
      return !!(!authUser.is_owner && authUser.can_access_hidden_lead_custom_fields);
    },
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        record: {
          custom_fields: [],
        }
      };
    },
    allCustomFields() {
      // NOTE: If you want to show historical custom fields than change this to recordCustomFieldsWithTrashed
      return this.$store.getters.recordCustomFields;
    },
    recordCustomFields() {
      return this.$store.state.activeRecord.record.custom_fields;
    },
    customFields() {
      return this.allCustomFields.map(customField => {
          const recordField = this.recordCustomFields.find(field => field.id === customField.id);
          return {
            id: customField.id,
            order: customField.order,
            value: (recordField && recordField.value) ? recordField.value : null, //customField.default_value,
            type: customField.type,
            customFieldableType: customField.custom_fieldable_type,
            label: customField.label,
            options: customField.options,
            visible: customField.visible,
            hiddenToUser: customField.hidden_to_user,
          }
        })
        .filter(customField => !(customField.hiddenToUser && !this.canAccessHiddenFields))
        .sort((a, b) => a.order - b.order);
    },
    visibleCustomFields() {
      return this.customFields.filter(customField => customField.visible === true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
